module.exports = __webpack_public_path__ + "media/images/flags/EE-d567fb83bfcd2e6a83637a8c5fe3740b.svg";